import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import SingleOptimizer from "components/Optimizer/Single/SingleOptimizer";

import * as optimizerReducer from "containers/SingleOptimizer/reducer";
import * as viewReducer from "containers/View/reducer";
import * as setupReducer from "containers/Setup/reducer";

const getRunId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.runId
      ? props.match.params.runId
      : 2860;

class OptimizerContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    props.init();
  }

  componentDidUpdate(prevProps) {
    const { id, init } = this.props;

    if (prevProps.id !== id) {
      init();
    }
  }

  render() {
    return <SingleOptimizer {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getRunId(ownProps);

  return {
    init: () => dispatch(optimizerReducer.init(id)),
    updateDrilldownValue: (runId, value) => dispatch(optimizerReducer.updateDrilldownValue(id, runId, value)),
    setBudget: (budget) => dispatch(optimizerReducer.setBudget(id, budget)),

    updateTruePositive: (id, val) => dispatch(setupReducer.updateTruePositive(id, val, true)),
    updateFalsePositive: (id, val) => dispatch(setupReducer.updateFalsePositive(id, val, true)),
    updateTrueNegative: (id, val) => dispatch(setupReducer.updateTrueNegative(id, val, true)),
    updateFalseNegative: (id, val) => dispatch(setupReducer.updateFalseNegative(id, val, true)),

    updateConversionGain: (id, val) => dispatch(setupReducer.updateConversionGain(id, val, true)),
    updateConversionCost: (id, val) => dispatch(setupReducer.updateConversionCost(id, val, true)),
    updateConversionMissed: (id, val) => dispatch(setupReducer.updateConversionMissed(id, val, true)),
    updateConversionSaved: (id, val) => dispatch(setupReducer.updateConversionSaved(id, val, true)),

    updateCustomValue: (id, blueprintId, valId, value) =>
      dispatch(setupReducer.updateCustomValue(id, blueprintId, valId, value))

    /*
    handleCreateDrilldown: drilldownColumn =>
      dispatch(optimizerReducer.handleCreateDrilldown(id, drilldownColumn)),

    setFirstRunId: runId => dispatch(optimizerReducer.setFirstRunId(id, runId)),
    setSecondRunId: runId =>
      dispatch(optimizerReducer.setSecondRunId(id, runId)),

    setMarketingRunId: runId =>
      dispatch(optimizerReducer.setMarketingRunId(id, runId)),
    setSalesRunId: runId => dispatch(optimizerReducer.setSalesRunId(id, runId)),


    setSalesBudget: budget =>
      dispatch(optimizerReducer.setSalesBudget(id, budget)),
    setOverallScaleFromRowCount: rowCount =>
      dispatch(optimizerReducer.setOverallScaleFromRowCount(id, rowCount)),

    setDrilldownColumn: val =>
      dispatch(optimizerReducer.setDrilldownColumn(id, val)),
    setSalesDrilldown: val =>
      dispatch(optimizerReducer.setSalesDrilldown(id, val)),
    setMarketingDrilldown: val =>
      dispatch(optimizerReducer.setMarketingDrilldown(id, val)),

    resetCosts: id => dispatch(setupReducer.resetCosts(id)),

    updateOverallRun: (isMarketing, value, valueRunId) =>
      dispatch(
        optimizerReducer.updateOverallRun(id, isMarketing, value, valueRunId)
      ),
    updateSalesRun: (value, valueRunId) =>
      dispatch(optimizerReducer.updateSalesRun(id, value, valueRunId)),
    updateMarketingRun: (value, valueRunId) =>
      dispatch(optimizerReducer.updateMarketingRun(id, value, valueRunId)),
    updateCombined: (isMarketing, first, second, runId) =>
      dispatch(
        optimizerReducer.updateCombined(id, isMarketing, first, second, runId)
      )
    */
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getRunId(ownProps);

  return {
    errorRuns: optimizerReducer.getErrorRuns(state, id),
    optimizer: optimizerReducer.getOptimizer(state, id),
    optimized: optimizerReducer.getOptimized(state, id),
    modelGroups: optimizerReducer.getModelGroups(state, id),

    groupInfo: optimizerReducer.getGroupInfo(state, id),

    runs: viewReducer.getRuns(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(OptimizerContainer);
